import update from 'immutability-helper';
import * as _ from 'lodash';
import { makeActionCreator } from '../../../../crazyEditor/redux/helpers';
import { LOCATION_CHANGE } from 'react-router-redux';
const GLOBAL_UPDATE = 'globalUpdate/GLOBAL_UPDATE';
import {Map} from 'immutable'

export default function reducer(state: any = {}, action: any = {}) {
  switch (action.type) {
    case GLOBAL_UPDATE:
      return update(state, action.update);
    case LOCATION_CHANGE:
      if (_.get(state, 'routing.locationBeforeTransitions.pathname') !== action.payload.pathname) {
        return update(state, {
          panel: {
            $set: {
              openedLazyPanels: [],
              openedStaticPanels: [],
              dynamicElements: Map(),
            }
          }
        });
      }
      break;
    default:
      break;
  }
  return state;
}

export const doGlobalUpdate = makeActionCreator(GLOBAL_UPDATE, 'update');
